// src/modules/app-views/toolbox/pages/Ai/modals/InfoModal/Step1.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Alert } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const InfoModalStepContent = () => {
  // ---------------------------------------------------------------------------
  // 9. UI
  // ---------------------------------------------------------------------------
  return (
    <Alert
      type="info"
      showIcon
      title={translateX('ai_catalog_tool_info_alert')}
      style={{ marginTop: 8 }}
    />
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
function infoModalStep() {
  return {
    stepTitle: 'how_to_catalog_tools_with_ai',
    stepTooltip: 'ai_catalog_instructions',
    content: () => <InfoModalStepContent />,
    validationFields: [],
  };
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default infoModalStep;
